// extracted by mini-css-extract-plugin
export default {"cls1":"bYgzREQhEseCc7dElogg","cls2":"TqVsamh8kbWmOwcDqiLZ bYgzREQhEseCc7dElogg"};